// Etapa 1: Identificação

import React from "react";
import { DadosEmpresa } from "./DadosEmpresa";
import { SelecaoCnae } from "./SelecaoCnae";
import { FormResponsavel } from "./FormResponsavel";
import {
  OrcamentoFornecedorData,
  DadosIdentificacao,
  ResponsavelOrcamento,
} from "../../../types/orcamento-fornecedor.types";

interface Etapa1Props {
  dadosOrcamento: OrcamentoFornecedorData;
  dadosIdentificacao: Partial<DadosIdentificacao>;
  onDadosChange: (dados: Partial<DadosIdentificacao>) => void;
  errors: Record<string, string>;
  showErrors?: boolean;
}

export const Etapa1Identificacao: React.FC<Etapa1Props> = ({
  dadosOrcamento,
  dadosIdentificacao,
  onDadosChange,
  errors,
  showErrors = false,
}) => {
  const handleCnaeChange = (cnaeIds: string[]) => {
    onDadosChange({ cnaeIds });
  };

  const handleResponsavelChange = (
    field: keyof ResponsavelOrcamento,
    value: string
  ) => {
    onDadosChange({
      responsavel: {
        ...(dadosIdentificacao.responsavel || {}),
        [field]: value,
      } as ResponsavelOrcamento,
    });
  };

  return (
    <div className="space-y-6">
      <DadosEmpresa
        fornecedor={dadosOrcamento.fornecedor}
        // O do cadastro é só ponto de partida: vale o que o fornecedor
        // informar, e a string vazia é resposta válida (ele apagou de propósito).
        telefone={
          dadosIdentificacao.telefoneEmpresa ??
          dadosOrcamento.fornecedor.telefone ??
          ""
        }
        onTelefoneChange={(telefoneEmpresa) => onDadosChange({ telefoneEmpresa })}
        erro={errors.telefoneEmpresa}
        mostrarErro={showErrors}
      />

      <SelecaoCnae
        cnaes={dadosOrcamento.fornecedor.cnaes}
        selectedIds={dadosIdentificacao.cnaeIds ?? []}
        onChange={handleCnaeChange}
        error={errors.cnaeIds}
      />

      <FormResponsavel
        data={dadosIdentificacao.responsavel || {}}
        onChange={handleResponsavelChange}
        errors={errors}
        showErrors={showErrors}
      />
    </div>
  );
};
